// removed by extract-text-webpack-plugin
module.exports = {"faq-item":"faq-item__3SUWb","faq-question":"faq-question__bie6p","faq-answer":"faq-answer__3M-K4","faq-note":"faq-note__3Mmhv","faq-answer-hide":"faq-answer-hide__2fLmW"};


//////////////////
// WEBPACK FOOTER
// ./pages/currency/components/FAQ/faqdropdown/faqdropdown.scss
// module id = 587
// module chunks = 68